export enum NotificationChannel {
  EMAIL = "EMAIL",
  SMS = "SMS",
  IN_APP = "IN_APP",
  PUSH_NOTIFICATION = "PUSH_NOTIFICATION",
}
